import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    Icon,
    MenuItem,
    Button,
    Divider,
    darken,
    Fab,
    Backdrop,
    ButtonGroup,
    IconButton,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DeleteIcon from "@material-ui/icons/Delete";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AddIcon from "@material-ui/icons/Add";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import clsx from "clsx";
import Feedback from "../../atoms/Feedback";
import {
    updateVISA, 
    submitVISA,
    getVISAs, 
    getVISA, 
} from "../../../actions/travelActions/visaActions";
import { getUsersList, getProfile } from "../../../actions/userActions";
import { countries, customersArray } from "../../../utils";
import { uploadDocument } from "../../../actions/vendorsActions";
import ItineraryModal from "./modals/ItineraryModal";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold",
    },
    title2: {
        display: "block",
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
        marginBottom: 10,
    },
    title3: {
        display: "block",
        fontSize: 12,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
    },
    appBar: {
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    paper1: {
        padding: theme.spacing(2),
        paddingBottom: 0,
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.15) : darken("#fff", 0.80),
    },
    paper0: {
        padding: theme.spacing(2),
        marginBottom: 20,
        paddingBottom: 0,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper2: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    backBtn: {
        letterSpacing: 2.5,
        padding: theme.spacing(1.2),
        paddingLeft: 20,
        paddingRight: 20,
    },
    status: {
        width: "fit-content",
        color: "#979292",
        padding: 6,
        background: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    statusTitle: {
        color: "#b5b5b5",
        fontSize: "0.75rem",
    },
    statusTitle2: {
        color: "#fff",
        fontSize: "0.75rem",
        paddingLeft: 10,
        paddingRight: 10,
    },
    statusDarkGreen: {
        color: "#fff",
        backgroundColor: "#4caf50",
    },
    statusGreen: {
        color: "#fff",
        backgroundColor: "#1de9b6",
    },
    statusYellow: {
        color: "#fbc02d",
        backgroundColor: "#fbc02d",
    },
    statusRed: {
        color: "#fff",
        backgroundColor: "#ef5350",
    },
    statusOrange: {
        color: "#fff",
        backgroundColor: "#ff9800",
    },
    embed: {
        width: "100%",
        height: 100,
        objectFit: "contain",
        objectPosition: "center",
        marginRight: 5,
        cursor: "pointer",
        transition: "all 300ms ease-in-out",
        zIndex: 1,
        "&:hover": {
            transform: "scale(2.5)",
            zIndex: 1000000000000,
        },
    },
    audit: {
        padding: 10,
        fontFamily: "Rubik",
        fontSize: 10,
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditTitle: {
        padding: 10,
        // background: theme.palette.grey[600],
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#cccccc",
        fontFamily: "Rubik",
        fontSize: 10,
        fontWeight: "bold",
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditContainer: {
        width: "100%",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    small: {
        fontSize: 11,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    link: {
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    centered: {
        textAlign: "center",
    },
    paperBlack: {
        color: "#f5f5f5",
        // background: "#3c3737",
        background: theme.palette.grey.A400,
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        textAlign: "center",
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
    },
    info2: {
        marginBottom: 20,
        fontWeight: 500,
    },
}));

const INIT_STATE = {
    employee: "",
    employeeName:"",
    division: "",
    divisionName:"",
    month: "",
    year: "",
    userType: "",
    forSomeoneElse: "",
    applicant: null,
    travelPurpose:"",
    purposeOther:"",
    customer:"",
    projectCode:"",
    projectDescription:"",
    projectAsset:"",
    projectAddedDesc:"",
    visaType:"",
    visaStatus:"",
    attachments: [],
};

const INIT_APPLICANT = {
    name:"",
    email:"",
    applicantId:"",
    phoneNumber:"",
    division:"",
    dateofbirth:"",
};

const INIT_ITEM = {
    name:"",
    passportNumber:"",
    passport:"",
    nationality:"",
    departureDate:"",
    arrivalDate:"",
    applicationCountry:"",
    expiryDate:"",
    visitingCountry:"",
};

const STATUS_BY_TYPE = {
    Visiting: ["New", "Renewal"],
    Business: ["Extension", "New"],
    "Residence Permit": ["New", "Renewal"],
    "Subject to Regularization (STR)": ["New"],
    "Temporary Work Permit (TWP)": ["Extension", "New", "Recurrent"],
};

const EditVisa = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [departureDate, setDepartureDate] = useState(new Date());
    const [arrivalDate, setArrivalDate] = useState(new Date());
    const [expiryDate, setExpiryDate] = useState(new Date());
    const { loading, error, visa } = useSelector((state) => state.visa);
    const { ppmusers } = useSelector((state) => state.user);

    const [applicant, setApplicant] = useState(INIT_APPLICANT);
    const [item, setItem] = useState(INIT_ITEM);
    const [passportFile, setPassportFile] = useState(undefined);
    const [theUrl, setTheUrl] = useState("");
    const [openDoc, setOpenDoc] = useState(false);
    const [load, setLoad] = useState(false);
    
    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        dispatch(getVISAs());
        dispatch(getVISA(id));
        dispatch(getProfile());
        dispatch(getUsersList())
    }, [dispatch, id]);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            employee: (visa && visa.employee) || "",
            employeeName: (visa && visa.employee?.userName) || "",
            requestDate: (visa && visa.requestDate) || "",
            division: (visa && visa.division) || "",
            divisionName: (visa && visa.division?.name) || "",
            
            userType: (visa && visa.userType) || "",
            forSomeoneElse: (visa && visa.forSomeoneElse) || "",
            applicant: (visa && visa.applicant) || null,
            travelPurpose: (visa && visa.travelPurpose) || "",
            purposeOther: (visa && visa.purposeOther) || "",
            customer: (visa && visa.customer) || "",
            projectCode: (visa && visa.projectCode) || "",
            projectDescription: (visa && visa.projectDescription) || "",
            projectAsset: (visa && visa.projectAsset) || "",
            projectAddedDesc: (visa && visa.projectAddedDesc) || "",
            visaType: (visa && visa.visaType) || "",
            visaStatus: (visa && visa.visaStatus) || "",
            attachments: (visa && visa.attachments) || [],

            status: (visa && visa.status) || "",
            documentNo: (visa && visa.documentNo) || "",

            createdBy: (visa && visa.createdBy) || "",
            createdAt: (visa && visa.createdAt) || "",

            submittedBy: (visa && visa.submittedBy) || "",
            submittedAt: (visa && visa.submittedAt) || "",

            approvedBy: (visa && visa.approvedBy) || "",
            approvedAt: (visa && visa.approvedAt) || "",
            approveComment: (visa && visa.approveComment) || "",
            
            rejectedBy: (visa && visa.rejectedBy) || "",
            rejectedAt: (visa && visa.rejectedAt) || "",
            rejectComment: (visa && visa.rejectComment) || "",

            acceptedBy: (visa && visa.acceptedBy) || "",
            acceptedAt: (visa && visa.acceptedAt) || "",
            acceptComment: (visa && visa.acceptComment) || "",

            declinedBy: (visa && visa.declinedBy) || "",
            declinedAt: (visa && visa.declinedAt) || "",
            declineComment: (visa && visa.declineComment) || "",

        }));
    }, [visa]);

     useEffect(() => {
        if(visa?.applicant !== null){
            setApplicant((prev) => ({
                ...prev,
                name: (visa?.applicant && visa?.applicant?.name) || "",
                email: (visa?.applicant && visa?.applicant?.email) || "",
                applicantId: (visa?.applicant && visa?.applicant?.applicantId) || "",
                phoneNumber: (visa?.applicant && visa?.applicant?.phoneNumber) || "",
                division: (visa?.applicant && visa?.applicant?.division) || "",
                dateofbirth: (visa?.applicant && visa?.applicant?.dateofbirth) || "",
            }));
        }
     },[visa]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleItem = (e) => {
        e.persist();
        setItem((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };
    
    const statusOptions = state.visaType ? STATUS_BY_TYPE[state.visaType] ?? [] : [];

    const handleApplicant = (e) => {
        e.persist();
        setApplicant((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleChangeDOB = (val) => {
        setApplicant((prev)=> ({...prev, dateofbirth: val}))
    };
    const handleChangeDepartureDate = (val) => {
        setDepartureDate(val);
    };
    const handleChangeArrivalDate = (val) => {
        setArrivalDate(val);
    };
    const handleChangeExpiryDate = (val) => {
        setExpiryDate(val);
    };

    React.useEffect(() => {
        if (departureDate !== "" && arrivalDate !== "" && expiryDate !== "") {
            setItem((prev) => ({
                ...prev,
                departureDate: moment(departureDate._d).format('DD/MM/YYYY'),
                arrivalDate: moment(arrivalDate._d).format('DD/MM/YYYY'),
                expiryDate: moment(expiryDate._d).format('DD/MM/YYYY'),
            }));
        }
    }, [departureDate, arrivalDate, expiryDate]);

    const handleUploadPassport = (e) => {
        const { files } = e.target;
        setPassportFile(files[0]);
    };
    
    useEffect(() => {
        const upload = async () => {
            if (passportFile) {
                setLoad(true)
                const formData = new FormData();
                formData.append("doc", passportFile);
                let url = await new Promise((resolve, reject) => {
                    resolve(dispatch(uploadDocument(formData)));
                });
                if (url) {
                    setItem((prev) => ({...prev, passport: url }));
                    setPassportFile(null);
                    setLoad(false)
                }
            }
        };
        upload();
    }, [passportFile, dispatch]);

    const handleAddItemArray = (item) => {
        if (item.name !== "" && item.passportNumber !== "" && item.passport !== "" && item.departureDate !== "" && item.arrivalDate !== "" && item.applicationCountry !== "" && item.visitingCountry !== "" && item.expiryDate !== "" && item.nationality !== "") {
            setState((prev) => ({
                ...prev,
                attachments: prev.attachments.concat([item]),
            }));
            setItem(INIT_ITEM);
        }
    };

    const handleRemoveItemArray = (i) => {
        setState((prev) => ({
            ...prev,
            attachments: prev.attachments.filter(
                (_, index) => index !== i
            ),
        }));
    };

    const handleOpenDoc = (url) => {
        setTheUrl(null);
        if(url){
            setTheUrl(url);
            setOpenDoc(true);
        }
    };
    
    const handleCloseDoc = () => {
        setOpenDoc(false);
    };
    
    const handleSubmitHandler = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            attachments: state.attachments,
            applicant: applicant,
            id,
            path: `travel/visa/view/${id}`,
        };
        await dispatch(submitVISA(data));
        await dispatch(getVISAs);
        setFeed((prev) => ({
            loading: false,
            open: !prev.open,
            message: "Visa Application Submitted Successfully.",
            success: true,
        }));
        setTimeout(() => {
            history.push("/travel/visa");
        }, 1500);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const data = {
            forSomeoneElse: state.forSomeoneElse,
            userType: state.userType,
            attachments: state.attachments,
            applicant: applicant,
            travelPurpose: state.travelPurpose,
            purposeOther: state.purposeOther,
            visaType: state.visaType,
            visaStatus: state.visaStatus,
            customer: state.customer,
            projectCode: state.projectCode,
            projectDescription: state.projectDescription,
            projectAsset: state.projectAsset,
            projectAddedDesc: state.projectAddedDesc,
            id
        }
        await dispatch(updateVISA(data));
        setTimeout(async () => {
            await dispatch(getVISA(id));
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: "Visa Application Updated Successfully.",
                success: true,
            }));
        }, 500);
    };

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    const isCanEdit = state ? state.status &&
        ((state.status === "draft" ||
            state.status === "declined" ||
            state.status === "rejected")
        )
        : false;

    return (
        <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}

                <ItineraryModal {...{ openDoc, handleCloseDoc, docs: theUrl }} />

                <Typography variant="overline" className={classes.title}>
                    Edit Visa Application
                </Typography>

                <Grid container justify="space-between" alignItems="center" spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.backBtn}
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => history.push("/travel/visa")}
                        >
                            Back
                        </Button>
                    </Grid>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Grid item>
                                <Paper variant="outlined" className={classes.status}>
                                    <Typography variant="overline" className={classes.statusTitle}>
                                        Document No.
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    {loading ? "Loading..." : state.documentNo}
                                    
                                </Paper>
                            </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                <Paper
                                    variant="outlined"
                                    className={clsx(
                                        state.status === "draft"
                                            ? classes.statusYellow
                                            : state.status === "submitted"
                                                ? classes.statusOrange
                                                : (state.status === "accepted" || state.status === "approved" || state.status === "confirmed" || state.status === "consented") ? classes.statusGreen
                                                    : (state.status === "issued" || state.status === "collected" || state.status === "transferred" || state.status === "returned" || state.status === "received" || state.status === "completed")
                                                        ? classes.statusDarkGreen
                                                        : classes.statusRed,
                                        classes.status
                                    )}
                                >
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        Status
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        {loading ? "Loading..." : state.status}
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>                        
                    </Grid>
                </Grid>

                <Paper variant="outlined" square className={classes.paper}>            
                    <form onSubmit={handleSubmitHandler}>
                        <div>
                        <Paper variant="outlined" square className={classes.paper0} >
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                    label="Employee Name"
                                    name="employeeName"
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    value={(state.employeeName && state.employeeName) || ""}
                                    required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        className={classes.marginBottom}
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Date Created"
                                        fullWidth
                                        required
                                        name="requestDate"
                                        inputVariant="outlined"
                                        value={state.requestDate}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Division/Unit"
                                        name="division"
                                        variant="outlined"
                                        fullWidth
                                        value={(state.division && state.divisionName) || ""}
                                        disabled
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Are you filling on behalf of someone else?</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "forSomeoneElse",
                                                name: "forSomeoneElse",
                                            }}
                                            placeholder="Are you filling on behalf of someone else?"
                                            label="Are you filling on behalf of someone else?"
                                            value={state.forSomeoneElse || ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                            
                                {(state.forSomeoneElse === "Yes") && (<>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>User Type</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "userType",
                                                    name: "userType",
                                                }}
                                                placeholder="User Type"
                                                label="User Type"
                                                value={state.userType || ""}
                                                onChange={handleChange}
                                            >
                                                <MenuItem disabled>Select Option</MenuItem>
                                                <MenuItem value="Internal">Internal Staff</MenuItem>
                                                <MenuItem value="External">Non-Staff</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {(state.userType === "Internal") && ( <>
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                id="ppmusers"
                                                options={ppmusers}
                                                value={applicant}
                                                debug
                                                onChange={(event, newValue) => {
                                                    setApplicant((prev) => ({
                                                        ...prev,
                                                        name: newValue?.userName && newValue?.userName,
                                                        email: newValue?.email && newValue?.email,
                                                        applicantId: newValue?.employeeId && newValue?.employeeId,
                                                        phoneNumber: newValue?.phone && newValue?.phone,
                                                        division: newValue?.division?.name && newValue?.division?.name,
                                                    }));
                                                }}
                                                getOptionLabel={(option) => option.userName || ""}
                                                renderOption={(option) => (
                                                    <React.Fragment>{option.userName}</React.Fragment>
                                                )}
                                                renderInput={(params) => (
                                                    <>
                                                        <TextField
                                                            {...params}
                                                            placeholder="Search by Name"
                                                            fullWidth
                                                            required
                                                            variant="outlined"
                                                            value={(applicant && applicant?.name) || ""}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: "disabled",
                                                                name: "applicant",
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            />
                                        </Grid>
                                    </>)}
                                </>)}
                            </Grid>
                        </Paper>

                        {((state.userType === "External") || (state.applicant && state.applicant?.name)) && ( <> 
                            <Typography variant="overline" className={classes.title2}>
                                APPLICANT DETAILS
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper0}>
                                <Grid container justify="center" alignItems="center" spacing={2} className={classes.grid}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Applicant Name"
                                            name="name"
                                            value={applicant?.name || ""}
                                            onChange={handleApplicant}
                                            disabled={state.forSomeoneElse === "No" || state.userType === "Internal"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Applicant Email"
                                            name="email"
                                            type="email"
                                            value={applicant?.email || ""}
                                            onChange={handleApplicant}
                                            disabled={state.forSomeoneElse === "No" || state.userType === "Internal"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Applicant Phone Number"
                                            name="phoneNumber"
                                            value={applicant?.phoneNumber || ""}
                                            onChange={handleApplicant}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Applicant ID"
                                            name="applicantId"
                                            value={applicant?.applicantId || ""}
                                            onChange={handleApplicant}
                                            disabled={state.forSomeoneElse === "No" || state.userType === "Internal"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <DatePicker
                                            autoOk
                                            format="DD/MM/yyyy"
                                            views={["year", "month", "date"]}
                                            label="Applicant Date of Birth"
                                            placeholder="Applicant Date of Birth"
                                            fullWidth
                                            inputVariant="outlined"
                                            value={applicant?.dateofbirth || new Date()}
                                            onChange={handleChangeDOB}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}></Grid>
                                </Grid>
                            </Paper>
                        </> )}

                        <Typography variant="overline" className={classes.title2}>
                            VISA DETAILS
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Purpose of Travel</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "travelPurpose",
                                                name: "travelPurpose",
                                            }}
                                            label="Purpose of Travel"
                                            placeholder="Purpose of Travel"
                                            value={state.travelPurpose || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="Vacation">Vacation</MenuItem>
                                            <MenuItem value="Training">Training</MenuItem>
                                            <MenuItem value="Seminar">Seminar</MenuItem>
                                            <MenuItem value="Conference">Conference</MenuItem>
                                            <MenuItem value="Project">Project</MenuItem>
                                            <MenuItem value="Others">Others</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {(state.travelPurpose === "Others") && (
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="purposeOther"
                                            name="purposeOther"
                                            label="Travel Purpose Description"
                                            placeholder="Travel Purpose Description"
                                            value={state.purposeOther || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required={state.travelPurpose === "Others"}
                                        />
                                    </Grid>    
                                )}
                                {(state.travelPurpose === "Project") && ( <>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>Customer Name</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "customer",
                                                    name: "customer",
                                                }}
                                                label="Customer"
                                                placeholder="Customer"
                                                value={state.customer || ""}
                                                onChange={handleChange}
                                            >
                                                {customersArray && customersArray.map((item, i) => (
                                                <MenuItem key={i} value={item.name}>
                                                    {item.name}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="projectCode"
                                            name="projectCode"
                                            placeholder="Project Code"
                                            label="Project Code"
                                            value={state.projectCode || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required={state.travelPurpose === "Project"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="projectDescription"
                                            name="projectDescription"
                                            placeholder="Project Description"
                                            label="Project Description"
                                            value={state.projectDescription || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required={state.travelPurpose === "Project"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="projectAsset"
                                            name="projectAsset"
                                            placeholder="Asset/Facilities"
                                            label="Asset/Facilities"
                                            value={state.projectAsset || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required={state.travelPurpose === "Project"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="projectAddedDesc"
                                            name="projectAddedDesc"
                                            placeholder="Project Added Description"
                                            label="Project Added Description"
                                            value={state.projectAddedDesc || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required={state.travelPurpose === "Project"}
                                        />
                                    </Grid>
                                </>)}
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Type of Visa</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "visaType",
                                                name: "visaType",
                                            }}
                                            label="Type of Visa"
                                            placeholder="Type of Visa"
                                            value={state.visaType || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="Visiting">Visiting</MenuItem>
                                            <MenuItem value="Business">Business</MenuItem>
                                            <MenuItem value="Residence Permit">Residence Permit</MenuItem>
                                            <MenuItem value="Subject to Regularization (STR)">Subject to Regularization (STR)</MenuItem>
                                            <MenuItem value="Temporary Work Permit (TWP)">Temporary Work Permit (TWP)</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Visa Status</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "visaStatus",
                                                name: "visaStatus",
                                            }}
                                            label="Visa Status"
                                            placeholder="Visa Status"
                                            value={state.visaStatus || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            {statusOptions && statusOptions.map((status, i) => (
                                                <MenuItem key={i} value={status}>
                                                    {status}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            ATTACH PASSPORT
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {item && (<>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="name"
                                        name="name"
                                        placeholder="Name (same as passport)"
                                        label="Name (same as passport)"
                                        value={item.name || ""}
                                        onChange={handleItem}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="passportNumber"
                                        name="passportNumber"
                                        placeholder="Passport Number"
                                        label="Passport Number"
                                        value={item.passportNumber || ""}
                                        onChange={handleItem}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <input
                                            type="file"
                                            label="Upload Passport"
                                            variant="outlined"
                                            accept="image/*,.pdf"
                                            id="file"
                                            defaultValue={(item.passport && item.passport) || ""}
                                            className={classes.input}
                                            onChange={handleUploadPassport}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Nationality</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "nationality",
                                                name: "nationality",
                                            }}
                                            label="Nationality"
                                            placeholder="Nationality"
                                            value={item.nationality || ""}
                                            onChange={handleItem}
                                        >
                                            {countries.map((item, i) => (
                                            <MenuItem key={i} value={item.label}>
                                                {item.label}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Expected Departure Date"
                                        placeholder="Expected Departure Date"
                                        fullWidth
                                        inputVariant="outlined"
                                        value={departureDate}
                                        onChange={handleChangeDepartureDate}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Expected Arrival Date"
                                        placeholder="Expected Arrival Date"
                                        fullWidth
                                        inputVariant="outlined"
                                        value={arrivalDate}
                                        onChange={handleChangeArrivalDate}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Applying From</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "applicationCountry",
                                                name: "applicationCountry",
                                            }}
                                            label="Applying From"
                                            placeholder="Applying From"
                                            value={item.applicationCountry || ""}
                                            onChange={handleItem}
                                        >
                                            {countries.map((item, i) => (
                                            <MenuItem key={i} value={item.label}>
                                                {item.label}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Passport Expiry Date"
                                        placeholder="Passport Expiry Date"
                                        fullWidth
                                        inputVariant="outlined"
                                        value={expiryDate}
                                        onChange={handleChangeExpiryDate}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Visiting Country</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "visitingCountry",
                                                name: "visitingCountry",
                                            }}
                                            label="Visiting Country"
                                            placeholder="Visiting Country"
                                            value={item.visitingCountry || ""}
                                            onChange={handleItem}
                                        >
                                            {countries.map((item, i) => (
                                            <MenuItem key={i} value={item.label}>
                                                {item.label}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <IconButton
                                        disabled={item.passport === null}
                                        onClick={() => handleOpenDoc(item.passport)}
                                    >
                                        <AttachFileIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={2}>
                                    <Button
                                        variant="outlined"
                                        color="default"
                                        disabled={item.name === ""}
                                        onClick={() => handleAddItemArray(item)}
                                        endIcon={<AddIcon fontSize="large" />}
                                    >
                                        Insert Item
                                    </Button>
                                </Grid>
                            </Grid> </>
                            )}
                        </Paper>

                        {state.attachments && state.attachments.length > 0 && (<>
                            
                        <Typography variant="overline" className={classes.title2}>
                            PASSPORT ATTACHMENTS
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            {state.attachments && state.attachments.map((sitem, i) => ( 
                                <Paper variant="outlined" square className={classes.paper1} key={i}>
                                    <Grid container spacing={2} className={classes.grid}>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                id="name"
                                                name="name"
                                                placeholder="Name (same as passport)"
                                                label="Name (same as passport)"
                                                value={sitem.name || ""}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                id="passportNumber"
                                                name="passportNumber"
                                                placeholder="Passport Number"
                                                label="Passport Number"
                                                value={sitem.passportNumber || ""}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>Nationality</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "nationality",
                                                        name: "nationality",
                                                    }}
                                                    label="Nationality"
                                                    placeholder="Nationality"
                                                    value={sitem.nationality || ""}
                                                    disabled
                                                >
                                                    {countries.map((item, i) => (
                                                    <MenuItem key={i} value={item.label}>
                                                        {item.label}
                                                    </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                id="departureDate"
                                                name="departureDate"
                                                placeholder="Expected Departure Date"
                                                label="Expected Departure Date"
                                                value={sitem.departureDate || ""}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                id="arrivalDate"
                                                name="arrivalDate"
                                                placeholder="Expected Arrival Date"
                                                label="Expected Arrival Date"
                                                value={sitem.arrivalDate || ""}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>Applying From</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "applicationCountry",
                                                        name: "applicationCountry",
                                                    }}
                                                    label="Applying From"
                                                    placeholder="Applying From"
                                                    value={sitem.applicationCountry || ""}
                                                    disabled
                                                >
                                                    {countries.map((item, i) => (
                                                    <MenuItem key={i} value={item.label}>
                                                        {item.label}
                                                    </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                id="expiryDate"
                                                name="expiryDate"
                                                placeholder="Passport Expiry Date"
                                                label="Passport Expiry Date"
                                                value={sitem.expiryDate || ""}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <FormControl fullWidth variant="outlined" required>
                                                <InputLabel>Visiting Country</InputLabel>
                                                <Select
                                                    inputProps={{
                                                        id: "visitingCountry",
                                                        name: "visitingCountry",
                                                    }}
                                                    label="Visiting Country"
                                                    placeholder="Visiting Country"
                                                    value={sitem.visitingCountry || ""}
                                                    disabled
                                                >
                                                    {countries.map((item, i) => (
                                                    <MenuItem key={i} value={item.label}>
                                                        {item.label}
                                                    </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={1}>
                                            <IconButton
                                                disabled={sitem.passport === null}
                                                onClick={() => handleOpenDoc(sitem.passport)}
                                            >
                                                <AttachFileIcon />
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={12} md={1}>
                                            <Fab
                                                color="secondary"
                                                onClick={() => handleRemoveItemArray(i)}
                                            >
                                                <DeleteIcon />
                                            </Fab>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            ))}
                        </Paper>
                        </>)}

                        <Grid container alignItems="center" wrap="nowrap" spacing={1} style={{ marginBottom: 5 }}>
                            <Grid item>
                                <Typography variant="overline" className={classes.title3}>
                                    Audit Trail
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Icon className="fas fa-clipboard-list" color="disabled" />
                            </Grid>
                        </Grid>

                        <Paper variant="outlined" square className={classes.paper}>
                            <Grid container justify="space-between" alignItems="center" spacing={2}>
                                {state.status === "draft" && (
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Created By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.createdBy && state.createdBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.createdAt}</span>
                                        </Paper>
                                    </Grid>
                                )}
                                {state.status !== "draft" && (
                                    <>
                                        <Grid item xs={12} md={12}>
                                            <Paper
                                                className={classes.auditContainer}
                                                component="div"
                                                elevation={1}
                                                variant="outlined"
                                                square
                                            >
                                                <span className={classes.auditTitle}>Submitted By</span>
                                                <Divider orientation="vertical" flexItem />
                                                <span className={classes.audit}>{state.submittedBy && state.submittedBy.userName}</span>
                                                <Divider orientation="vertical" flexItem />
                                                <span className={classes.audit}>{state.submittedAt}</span>
                                            </Paper>
                                        </Grid>
                                        {(state.rejectedAt && state.rejectedBy) && (
                                            <>
                                                <Grid item xs={12} md={12}>
                                                    <Paper
                                                        className={classes.auditContainer}
                                                        component="div"
                                                        elevation={1}
                                                        variant="outlined"
                                                        square
                                                    >
                                                        <span className={classes.auditTitle}>Rejected By</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectedBy && state.rejectedBy.userName}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectedAt}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.auditTitle}>Comment</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectComment}</span>
                                                    </Paper>
                                                </Grid>
                                            </>
                                        )}
                                        {(state.declinedAt && state.declinedBy) && (
                                            <>
                                                <Grid item xs={12} md={12}>
                                                    <Paper
                                                        className={classes.auditContainer}
                                                        component="div"
                                                        elevation={1}
                                                        variant="outlined"
                                                        square
                                                    >
                                                        <span className={classes.auditTitle}>Declined By</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declinedBy && state.declinedBy.userName}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declinedAt}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.auditTitle}>Comment</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declineComment}</span>
                                                    </Paper>
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </Paper>

                        {isCanEdit ? (
                            <Grid container justify="center">
                                <Grid item>
                                    <ButtonGroup>
                                        <Button
                                            className={classes.saveBtn}
                                            color="primary"
                                            variant="contained"
                                            disabled={loading}
                                            onClick={handleSave}
                                        >
                                            {loading ? "Loading..." : "Save Changes"}
                                        </Button>
                                        <Button
                                            type="submit"
                                            className={classes.saveBtn2}
                                            variant="contained"
                                            onClick={handleSubmitHandler}
                                            disabled={loading}
                                        >
                                            Submit
                                        </Button>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                        ) : null}
                        </div>
                    </form>
                </Paper>

            </MuiPickersUtilsProvider>

            <Backdrop className={classes.backdrop} open={loading || load}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default EditVisa;
